import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Scales } from "@phosphor-icons/react";
import { adminApi, getErrorMessage } from "@/lib/api";
import { Card, btnPrimary } from "../ui";
import { SCORE_LABELS } from "./parts";

const FIELDS = [
  ["auto_approve_limit_aud", "Auto-approval limit (AUD inc GST)", 0, 50000, 50],
  ["confidence_auto_approve", "Confidence needed to recommend approval", 50, 100, 1],
  ["confidence_further_info", "Below this, ask for more information", 0, 95, 1],
];
const inputCls = "w-20 bg-black/50 border border-neutral-800 rounded-lg px-2 py-1 text-sm text-white text-right tabular-nums outline-none focus:border-[#73bf44]";

export function AssessRules({ settings, onSaved }) {
  const [s, setS] = useState(settings);
  const [busy, setBusy] = useState(false);
  useEffect(() => setS(settings), [settings]);
  const sum = Object.values(s.weights || {}).reduce((a, b) => a + Number(b || 0), 0);
  const blank = FIELDS.some(([k]) => s[k] === "" || s[k] === null || s[k] === undefined) || Object.values(s.weights || {}).some((v) => v === "");
  const save = async () => {
    setBusy(true);
    try {
      const body = { ...Object.fromEntries(FIELDS.map(([k]) => [k, Number(s[k])])), weights: Object.fromEntries(Object.entries(s.weights).map(([k, v]) => [k, Number(v)])) };
      onSaved((await adminApi.put("/admin/wi/assess/settings", body)).data);
      toast.success("Assessment rules saved");
    } catch (e) { toast.error(getErrorMessage(e)); } finally { setBusy(false); }
  };
  return (
    <Card title="Assessment rules" icon={Scales} testId="wi-assess-rules">
      <div className="space-y-2.5">
        {FIELDS.map(([k, label, min, max, step]) => (
          <label key={k} className="flex items-center justify-between gap-3 text-xs text-neutral-400">{label}
            <input type="number" min={min} max={max} step={step} value={s[k] ?? ""} onChange={(e) => setS({ ...s, [k]: e.target.value })} className={inputCls} data-testid={`wi-rule-${k}`} />
          </label>
        ))}
        <div className="pt-2 border-t border-neutral-800">
          <div className="flex justify-between text-[0.62rem] uppercase tracking-[0.16em] font-bold text-neutral-500 mb-2">
            <span>Confidence weights</span><span className={sum === 100 ? "text-[#73bf44]" : "text-red-400"} data-testid="wi-weights-sum">{sum} / 100</span>
          </div>
          {Object.keys(SCORE_LABELS).map((k) => (
            <label key={k} className="flex items-center justify-between gap-3 text-xs text-neutral-400 mb-1.5">{SCORE_LABELS[k]}
              <input type="number" min={0} max={100} value={s.weights?.[k] ?? 0} onChange={(e) => setS({ ...s, weights: { ...s.weights, [k]: e.target.value } })} className={inputCls} data-testid={`wi-weight-${k}`} />
            </label>
          ))}
        </div>
        <p className="text-[0.7rem] text-neutral-600">Pricing tolerance ±{settings.pricing_tolerance_pct}% and {settings.min_comparables} comparable repairs come from the benchmark settings on Import & Validation.</p>
      </div>
      <button className={`${btnPrimary} mt-4`} onClick={save} disabled={busy || sum !== 100 || blank} data-testid="wi-assess-rules-save">Save rules</button>
    </Card>
  );
}
